"use strict";

angular
	.module('rmSidebar', []);

require('./controller');
require('./routes');